<template>
  <img
    v-if="userImage"
    :src="userImage"
    class="rounded-circle profile-image border border-2 border-dark"
    :alt="fullname"
    :style="{ width: size + 'px', height: size + 'px' }"
  />
  <UserIcon v-else :fullname="fullname" :size="size" :font-size="fontSize" />
</template>

<script>
import UserIcon from "@/components/activity/UserIcon.vue";

export default {
  name: "ProfileIcon",
  components: {
    UserIcon
  },
  props: {
    userImage: {
      type: String,
      default: null
    },
    fullname: {
      type: String,
      required: true
    },
    // size of the resulting image in pixels
    size: {
      type: [Number, String],
      default: 28
    },
    // font size of the user icon in rem
    fontSize: {
      type: [Number, String],
      default: "0.75"
    }
  }
};
</script>

<style scoped>
.profile-image {
  object-fit: cover;
}
</style>
